var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "eas-loader" }, [
    _c("div", { staticClass: "loader" }),
    _c("div", { staticClass: "loader-text" }, [
      _vm._v(_vm._s(_vm.$t("loading"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }